export const sum = (arr: number[]) => arr.reduce((acc, val) => acc + val, 0)

export const unique = <T>(arr: T[]): T[] => {
  return Array.from(new Set(arr))
}

export const definedIds = (items: { id?: number | null }[]): number[] =>
  items
    .map((item) => item.id)
    .filter((id): id is number => id !== undefined && id !== null)

export const definedIdSet = (items: { id?: number | null }[]): Set<number> =>
  new Set(definedIds(items))
